import GoogleMap from '../components/map';

class OurInvestments {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        this.root = el;
        this.mapEl = this.root.querySelector('[data-map]');
        this.map = null;

        return true;
    }

    init() {
        this.setMap();
    }

    setMap() {
        if (!this.mapEl) return;
        this.map = new GoogleMap(this.mapEl);
    }
}
const initOurInvestments = () => {
    const sections = document.querySelectorAll('[data-our-investments]');

    if (sections.length) {
        sections.forEach(item => new OurInvestments(item));
    }
};

initOurInvestments();
